import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import getDecryptData from '../../../helpers/getDecryptData';
import OrderAdvancedFilters from '../../components/OrderAdvancedFilters';
import { useThemeContext } from '../../../fetchdata/ThemeContext';
import AssignDriverSelect, { DriverAvatar } from '../../components/AssignDriverSelect';
import { components } from 'react-select';
import BookingDetailsModal, { BookingDetailsButton } from '../../components/BookingDetailsModal';

const MySwal = withReactContent(Swal);

const DriverOption = (props) => {
  const driver = props.data.driver;
  return (
    <components.Option {...props}>
      <div className="driver-select-option">
        <DriverAvatar driver={driver} size={36} />
        <div className="driver-select-copy">
          <div className="driver-select-name">{driver.username}</div>
          <div className="driver-select-meta">
            {driver.phone || 'No phone'} · {driver.onDuty ? 'On Duty' : Number(driver.online) === 1 ? 'Online' : 'Offline'}
            {driver.distanceKm != null ? ` · ${driver.distanceKm.toFixed(2)} km` : ''}
          </div>
        </div>
      </div>
    </components.Option>
  );
};

function AllOrder() {
  const { sendMessage } = useThemeContext();
  const toRad = (value) => (value * Math.PI) / 180;

  const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const [AllDriver, setAllDriver] = useState([]);
  const [driverProfiles, setDriverProfiles] = useState({});
  const [DriverId, setDriverId] = useState(null);
  const [OrderId, setOrderId] = useState(null);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({ fromDate: '', toDate: '', minHours: '', maxHours: '', filterType: 'driver', sortBy: 'orderId' });
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [formData, setFormData] = useState({ status: '', comment: '', otp: '' });
  const [cancelOrderId, setCancelOrderId] = useState(null);
  const [cancelComment, setCancelComment] = useState('');
  const [cancelledBy, setCancelledBy] = useState('admin');
  const [selectedBookingOrder, setSelectedBookingOrder] = useState(null);

  const handleDriverChange = (driverId) => {
    setDriverId(driverId || '');
  };

  const buildDriverProfileMap = (users = []) => (
    users.reduce((map, user) => {
      if (user?._id) map[user._id] = user;
      return map;
    }, {})
  );

  const mergeDriverProfile = (driver, profileMap = driverProfiles) => {
    if (!driver) return driver;
    const id = driver?._id || driver;
    const profileUser = profileMap[id];
    if (!profileUser || typeof driver !== 'object') return driver;
    return {
      ...driver,
      profile: driver.profile || profileUser.profile || profileUser.ProfileFile || '',
      ProfileFile: driver.ProfileFile || profileUser.ProfileFile || profileUser.profile || '',
      profileImage: driver.profileImage || profileUser.profileImage || '',
      avatar: driver.avatar || profileUser.avatar || '',
    };
  };

  const selectDriver = async (ordId, driver, cat, type, distance, empType) => {
    fetchemployeeData(cat, type, empType, distance, ordId);
    setOrderId(ordId);
    setDriverId(driver);
  };

  const fetchemployeeData = async (cat, type, empType, distance, currentOrderId) => {
    setAllDriver([]);
    try {
      const pickupLat = Number(distance?.latitude);
      const pickupLng = Number(distance?.longitude);
      const [response, profileResponse] = await Promise.all([
        axiosInstance.get(
          `/all-employee?type=${type}&longitude=${pickupLng || ''}&latitude=${pickupLat || ''}&empType=${empType}&status=1&currentOrderId=${currentOrderId || ''}`
        ),
        axiosInstance.get('/admin/all-user?page=1&limit=1000&type=1&empType=2&status=1'),
      ]);
      const profileMap = buildDriverProfileMap(profileResponse.data.users || []);
      setDriverProfiles((prev) => ({ ...prev, ...profileMap }));
      const { success, users } = response.data;
      if (success) {
        const updatedUsers = (users || [])
          .filter((user) => String(user.status) !== '0')
          .map((user) => {
            const profiledUser = mergeDriverProfile(user, profileMap);
            const driverLat = Number(user?.latitude);
            const driverLng = Number(user?.longitude);
            let distanceKm = null;
            if (!isNaN(pickupLat) && !isNaN(pickupLng) && !isNaN(driverLat) && !isNaN(driverLng)) {
              distanceKm = getDistanceInKm(pickupLat, pickupLng, driverLat, driverLng);
            }
            return { ...profiledUser, distanceKm };
          })
          .sort((a, b) => {
            if (a.onDuty !== b.onDuty) return a.onDuty ? 1 : -1;
            if (a.online !== b.online) return b.online - a.online;
            if (a.distanceKm == null && b.distanceKm == null) return 0;
            if (a.distanceKm == null) return 1;
            if (b.distanceKm == null) return -1;
            return a.distanceKm - b.distanceKm;
          });
        setAllDriver(updatedUsers);
      }
    } catch (error) {
      console.error('Error fetching Driver:', error);
    }
  };

  const handleClickDriverChange = async () => {
    try {
      const res = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { agentId: DriverId });
      if (res.data.success) {
        const assignmentSocketPayload = {
          type: 'book',
          orderId: OrderId,
          userId: DriverId,
          order: {
            orderId: OrderId,
            status: 'assigned',
            driverId: DriverId,
          },
        };

        sendMessage(assignmentSocketPayload);

        try {
          await axiosInstance.post('/send-push-old', {
            title: 'New Ride Assigned!',
            body: 'You have been assigned a new ride. Tap to view details.',
            type: 1,
            department: 'driver',
            userId: DriverId,
            orderId: OrderId,
          });
        } catch (pushError) {
          console.error('Error sending assignment push notification', pushError);
        }

        toast.success('Employee Updated successfully!');
      }
    } catch (error) {
      console.error('Error Updated Employee', error);
    } finally {
      fetchData();
    }
  };

  const fetchData = async (
    nextFilters = filters,
    nextSearchTerm = searchTerm,
    nextPage = currentPage,
    nextDriver = selectedDriver
  ) => {
    const decryptdatajson = await getDecryptData();
    let employeeId = null;
    const id = decryptdatajson?._id;
    if (decryptdatajson.type === 3) employeeId = id;
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: nextPage,
        limit,
        search: nextSearchTerm,
        status: formData.status,
        employeeId: employeeId || nextDriver?.value || '',
        filterType: employeeId ? 'driver' : nextFilters.filterType || 'driver',
        filterId: employeeId || nextDriver?.value || '',
        fromDate: nextFilters.fromDate,
        toDate: nextFilters.toDate,
        minHours: nextFilters.minHours,
        maxHours: nextFilters.maxHours,
        sortBy: nextFilters.sortBy || 'orderId',
      });
      const [response, profileResponse] = await Promise.all([
        axiosInstance.get(
          `/admin/all-order?${params.toString()}`
        ),
        axiosInstance.get('/admin/all-user?page=1&limit=1000&type=1&empType=2&status='),
      ]);
      const profileMap = buildDriverProfileMap(profileResponse.data.users || []);
      setDriverProfiles((prev) => ({ ...prev, ...profileMap }));
      const orderList = (response.data.Order || []).map((order) => ({
        ...order,
        agentId: order.agentId ? mergeDriverProfile(order.agentId, profileMap) : order.agentId,
      }));
      setData(orderList);
      setSelectedOrders([]);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
    } catch (error) {
       setData([]);
      setSelectedOrders([]);
      setCurrentPage(1);
      setTotalPages(1);
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, [currentPage, limit]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    const emptyFilters = { fromDate: '', toDate: '', minHours: '', maxHours: '', filterType: 'driver', sortBy: 'orderId' };
    setFilters(emptyFilters);
    setSearchTerm('');
    setSelectedDriver(null);
    setCurrentPage(1);
    fetchData(emptyFilters, '', 1, null);
  };

  const toggleOrderSelection = (orderId) => {
    setSelectedOrders((prev) => (
      prev.includes(orderId) ? prev.filter((id) => id !== orderId) : [...prev, orderId]
    ));
  };

  const toggleSelectAll = () => {
    if (selectedOrders.length === data.length) {
      setSelectedOrders([]);
      return;
    }
    setSelectedOrders(data.map((order) => order._id));
  };

  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.delete(`/admin/delete-order/${categoryId}`)
          .then(() => { fetchData(); toast.success('Deleting Ride success!'); })
          .catch(() => toast.error('Error deleting data'));
      }
    });
  };

  const handleBulkDelete = () => {
    if (selectedOrders.length === 0) {
      toast.error('Please select orders to delete');
      return;
    }

    MySwal.fire({
      title: 'Are you sure?',
      text: `This will delete ${selectedOrders.length} selected order${selectedOrders.length > 1 ? 's' : ''}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete selected!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.post('/admin/delete-orders', { orderIds: selectedOrders })
          .then(() => {
            fetchData();
            toast.success('Selected orders deleted successfully!');
          })
          .catch(() => toast.error('Error deleting selected orders'));
      }
    });
  };

  const handleStatusChange = (ratingId) => async (event) => {
    try {
      await axiosInstance.put(`/admin/update-order/${ratingId}`, { status: event.target.value });
      fetchData(currentPage);
      toast.success('Status Updated successfully!');
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handleCancelOrder = (categoryId) => {
    if (!cancelComment || cancelComment === '') { toast.error('Comment is required'); return; }
    if (!cancelledBy) { toast.error('Cancel by is required'); return; }
    const cancelByLabels = { admin: 'admin', user: 'user', driver: 'driver' };
    const mycomment = `Cancelled by ${cancelByLabels[cancelledBy] || 'admin'}: ${cancelComment}`;
    MySwal.fire({
      title: 'Are you sure?',
      text: 'This will cancel the order.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Cancel it!',
      cancelButtonText: 'No!',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.put(`/cancel-order/${categoryId}`, { comment: mycomment, cancelledBy, skipCancelCharge: true })
          .then(() => {
            fetchData();
            toast.success('Ride Cancelled Successfully!');
            setCancelComment('');
            setCancelledBy('admin');
            setCancelOrderId(null);
          })
          .catch(() => toast.error('Error Cancelling Ride'));
      }
    });
  };

  const handleCompleteOrder = (id) => {
    MySwal.fire({
      title: 'Complete Ride?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Complete it!',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.put(`/complete-order/${id}`, { otp: 0 })
          .then(() => {
            fetchData();
            toast.success('Ride Completed Successfully!');
          })
          .catch((error) => toast.error(error?.response?.data?.message || 'Error completing ride'));
      }
    });
  };

  const saveBlobAsPdf = (blobData, filename) => {
    const url = window.URL.createObjectURL(new Blob([blobData]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const downloadCustomerInvoice = async (id) => {
    try {
      const response = await toast.promise(
        axiosInstance.post('/download-invoice-order', { invoiceId: id }, { responseType: 'blob' }),
        {
          loading: 'Customer invoice downloading...',
          success: 'Customer invoice downloaded!',
          error: 'Failed to download customer invoice.',
        }
      );
      saveBlobAsPdf(response.data, 'customer-invoice.pdf');
    } catch (error) {
      console.error('Error downloading customer invoice:', error);
    }
  };

  const downloadDriverInvoice = async (id) => {
    try {
      const response = await toast.promise(
        axiosInstance.post('/download-invoice-order-vendor', { invoiceId: id }, { responseType: 'blob' }),
        {
          loading: 'Driver invoice downloading...',
          success: 'Driver invoice downloaded!',
          error: 'Failed to download driver invoice.',
        }
      );
      saveBlobAsPdf(response.data, 'driver-invoice.pdf');
    } catch (error) {
      console.error('Error downloading driver invoice:', error);
    }
  };

  const getStatusConfig = (status) => {
    const map = {
      0: { label: 'Cancelled', color: '#ef4444', bg: '#fef2f2', icon: 'bi-x-circle-fill' },
      1: { label: 'Placed',    color: '#3b82f6', bg: '#eff6ff', icon: 'bi-clock-fill' },
      2: { label: 'Accepted',  color: '#8b5cf6', bg: '#f5f3ff', icon: 'bi-check-circle-fill' },
      5: { label: 'Started',   color: '#f59e0b', bg: '#fffbeb', icon: 'bi-play-circle-fill' },
      7: { label: 'Completed', color: '#10b981', bg: '#ecfdf5', icon: 'bi-check2-all' },
    };
    return map[status] || { label: 'Unknown', color: '#6b7280', bg: '#f9fafb', icon: 'bi-question-circle' };
  };

  const getBookingType = (items) => {
    if (!items || items.length === 0) return 'N/A';
    const title = items[0]?.title || '';
    if (title.includes('Round')) return 'Round Trip';
    if (title.includes('One Way')) return 'One Way';
    if (title.includes('Outstation')) return 'Outstation';
    if (title.includes('Local')) return 'Local';
    return title;
  };

  const bookingColors = {
    'Round Trip':  { color: '#d97706', bg: '#fffbeb' },
    'One Way':     { color: '#2563eb', bg: '#eff6ff' },
    'Outstation':  { color: '#7c3aed', bg: '#f5f3ff' },
    'Local':       { color: '#059669', bg: '#ecfdf5' },
    'N/A':         { color: '#6b7280', bg: '#f9fafb' },
  };

  const getCancelledByText = (order) => {
    if (!order) return 'N/A';
    if (order.cancelledBy === 'admin') return 'Admin';
    if (order.cancelledBy === 'driver') return order.cancelledById?.username || order.agentId?.username || 'Driver';
    if (order.cancelledBy === 'user') return order.details?.[0]?.username || 'Customer';
    const comment = order.comment || '';
    if (/cancelled by admin/i.test(comment)) return 'Admin';
    if (/cancelled by driver/i.test(comment)) return order.agentId?.username || 'Driver';
    if (/cancelled by user|cancelled by customer/i.test(comment)) return order.details?.[0]?.username || 'Customer';
    return 'N/A';
  };

  const formatTextDateTime = (value) => {
    if (!value) return 'N/A';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const getOrderTextDetails = (order) => {
    if (!order) return '';
    const item = order.items?.[0] || {};
    const customer = order.details?.[0] || {};
    const driver = order.agentId || {};
    const status = getStatusConfig(order.status).label;
    const bookingType = getBookingType(order.items);
    const pickupFullAddress = order.pickupFullAddress || item.pickupFullAddress || item.pickup || order.location || 'N/A';
    const alternativePhone = order.alternativePhone || item.alternativePhone || 'N/A';

    return [
      `Ride ID: #${order.orderId || order._id || 'N/A'}`,
      `Status: ${status}`,
      `Booking Type: ${bookingType}`,
      '',
      'Customer Details',
      `Name: ${customer.username || 'N/A'}`,
      `Phone: ${customer.phone || 'N/A'}`,
      `Alternative Phone: ${alternativePhone}`,
      `Email: ${customer.email || 'N/A'}`,
      `Address: ${customer.address || 'N/A'}`,
      '',
      'Driver Details',
      `Name: ${driver.username || 'Not Assigned'}`,
      `Phone: ${driver.phone || 'N/A'}`,
      '',
      'Trip Details',
      `Pickup: ${item.pickup || order.location || 'N/A'}`,
      `Pickup Full Address: ${pickupFullAddress}`,
      `Drop: ${item.dropoff || 'N/A'}`,
      `Date: ${item.date || 'N/A'}`,
      `Time: ${item.time || 'N/A'}`,
      `Order Created: ${formatTextDateTime(order.createdAt)}`,
      `Trip Start: ${formatTextDateTime(order.startTime)}`,
      `Trip End: ${formatTextDateTime(order.endTime)}`,
      '',
      'Payment Details',
      `Total Amount: ₹${order.totalAmount ?? 0}`,
      `Paid Amount: ₹${order.paid ?? 0}`,
      `Payment Mode: ${order.mode || 'N/A'}`,
    ].join('\n');
  };

  const getBookingDetailRows = (order) => {
    if (!order) return [];
    const item = order.items?.[0] || {};
    const customer = order.details?.[0] || {};
    const driver = order.agentId || {};
    const bookingType = getBookingType(order.items);
    const pickupDateTime = [item.date, item.time].filter(Boolean).join(' ') || 'N/A';
    const bookingDateTime = order.createdAt ? formatTextDateTime(order.createdAt) : 'N/A';
    const address = customer.address || item.pickup || order.location || 'N/A';
    const pickupFullAddress = order.pickupFullAddress || item.pickupFullAddress || item.pickup || order.location || address;
    const alternativePhone = order.alternativePhone || item.alternativePhone || 'N/A';

    return [
      ['Order Id', `Order - ${order.orderId || order._id || 'N/A'}`],
      ['Customer Name', customer.username || 'N/A'],
      ['Pickup Time', pickupDateTime],
      ['Phone No', customer.phone || 'N/A'],
      ['Alternative Phone No', alternativePhone],
      ['Booking Date/Time', bookingDateTime],
      ['Booking Sub', bookingType],
      ['Booking Type', item.bookingType || item.tripType || order.bookingType || 'Local'],
      ['Pickup Address', item.pickup || order.location || address],
      ['Pickup Full Address', pickupFullAddress],
      ['Pickup Location', item.pickup || order.location || 'N/A'],
      ['Destination Address', item.dropoff || 'N/A'],
      ['Destination Location', item.dropoff || 'N/A'],
      ['No of Days', order.nightDays || item.day || item.fullday || 'NA'],
      ['Booking Distance', item.distance || order.distance || 'NA'],
      ['HR', item.hour || 'NA'],
      ['Car Name', item.carType || item.title || 'NA'],
      ['Remarks', order.comment || item.remark || 'NA'],
      ['Driver Name', driver.username || 'Not Assigned'],
      ['Driver Phone', driver.phone || 'N/A'],
      ['Trip Start', formatTextDateTime(order.startTime)],
      ['Trip End', formatTextDateTime(order.endTime)],
      ['Total Amount', `₹${order.totalAmount ?? 0}`],
      ['Payment Mode', order.mode || 'N/A'],
    ];
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="orders-page">

          {/* ── Page Header ── */}
          <div className="page-header">
            <div className="page-title">
              <div className="title-icon"><i className="bi bi-bag-check-fill"></i></div>
              <div>
                <h1>All Rides</h1>
                <p>Manage and track all customer bookings</p>
              </div>
            </div>
          </div>

          {/* ── Filters ── */}
          <div className="filter-card">
            <div className="filter-row order-filter-grid">
              <div className="filter-group filter-per-page">
                <label><i className="bi bi-list-ol me-1"></i>Per Page</label>
                <select value={limit} onChange={(e) => { setlimit(parseInt(e.target.value, 10)); setCurrentPage(1); }}>
                  {[5, 10, 15, 20, 25].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              <div className="filter-group filter-order-search">
                <label><i className="bi bi-search me-1"></i>Search by Ride ID</label>
                <div className="search-input-wrap">
                  <i className="bi bi-search search-icon"></i>
                  <input
                    type="text"
                    placeholder="Enter Ride ID..."
                    value={searchTerm}
                    onChange={(e) => { setCurrentPage(1); setTotalPages(1); setSearchTerm(e.target.value); }}
                    onKeyDown={(e) => e.key === 'Enter' && fetchData()}
                  />
                </div>
              </div>
              <div className="filter-group filter-date">
                <label><i className="bi bi-calendar3 me-1"></i>From Date</label>
                <input
                  className="filter-input"
                  type="date"
                  name="fromDate"
                  value={filters.fromDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-group filter-date">
                <label><i className="bi bi-calendar-check me-1"></i>To Date</label>
                <input
                  className="filter-input"
                  type="date"
                  name="toDate"
                  value={filters.toDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-group filter-hour hour-filter">
                <label><i className="bi bi-clock-history me-1"></i>Min Hours</label>
                <input
                  className="filter-input"
                  type="number"
                  min="0"
                  name="minHours"
                  value={filters.minHours}
                  onChange={handleFilterChange}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <OrderAdvancedFilters
                filters={filters}
                onFilterChange={handleFilterChange}
                selectedDriver={selectedDriver}
                onDriverChange={(driver) => {
                  setSelectedDriver(driver);
                  setCurrentPage(1);
                }}
                includeRange={false}
              />
              <div className="filter-group filter-hour hour-filter">
                <label><i className="bi bi-clock me-1"></i>Max Hours</label>
                <input
                  className="filter-input"
                  type="number"
                  min="0"
                  name="maxHours"
                  value={filters.maxHours}
                  onChange={handleFilterChange}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <div className="filter-group filter-sort">
                <label><i className="bi bi-sort-down me-1"></i>Sort By</label>
                <select name="sortBy" value={filters.sortBy} onChange={handleFilterChange}>
                  <option value="orderId">Order ID</option>
                  <option value="dateDesc">Date Newest</option>
                  <option value="dateAsc">Date Oldest</option>
                </select>
              </div>
              <div className="filter-group filter-action">
                <label>&nbsp;</label>
                <button className="search-btn" onClick={() => { setCurrentPage(1); fetchData(filters, searchTerm, 1); }}>
                  <i className="bi bi-search me-2"></i>Search
                </button>
              </div>
              <div className="filter-group filter-action">
                <label>&nbsp;</label>
                <button className="reset-btn" onClick={resetFilters}>
                  <i className="bi bi-arrow-counterclockwise me-2"></i>Reset
                </button>
              </div>
            </div>
          </div>

          {!loading && data.length > 0 && (
            <div className="bulk-bar">
              <label className="select-all-wrap">
                <input
                  type="checkbox"
                  checked={data.length > 0 && selectedOrders.length === data.length}
                  onChange={toggleSelectAll}
                />
                <span>Select all on this page</span>
              </label>
              <div className="bulk-actions">
                <span>{selectedOrders.length} selected</span>
                <button className="bulk-delete-btn" disabled={selectedOrders.length === 0} onClick={handleBulkDelete}>
                  <i className="bi bi-trash3 me-2"></i>Delete Selected
                </button>
              </div>
            </div>
          )}

          {/* ── Rides List ── */}
          {loading ? (
            <LoadingTable />
          ) : data.length === 0 ? (
            <div className="empty-state">
              <i className="bi bi-inbox"></i>
              <h3>No Rides Found</h3>
              <p>Try adjusting your search criteria</p>
            </div>
          ) : (
            <div className="orders-list">
              {data.map((row, idx) => {
                const statusCfg = getStatusConfig(row.status);
                const bookingType = getBookingType(row.items);
                const bookingColor = bookingColors[bookingType] || bookingColors['N/A'];
                const isTerminal = row.status === 0 || row.status === 7;

                return (
                  <div className={`order-card ${selectedOrders.includes(row._id) ? 'selected' : ''}`} key={row._id} style={{ animationDelay: `${idx * 0.04}s` }}>

                    {/* Card Header */}
                    <div className="order-card-header">
                      <div className="header-left">
                        <label className="order-select">
                          <input
                            type="checkbox"
                            checked={selectedOrders.includes(row._id)}
                            onChange={() => toggleOrderSelection(row._id)}
                          />
                        </label>
                        <span className="order-id">#{row.orderId}</span>
                        <span className="status-badge" style={{ color: statusCfg.color, background: statusCfg.bg }}>
                          <i className={`bi ${statusCfg.icon} me-1`}></i>{statusCfg.label}
                        </span>
                        <span className="booking-badge" style={{ color: bookingColor.color, background: bookingColor.bg }}>
                          <i className="bi bi-tag me-1"></i> {row?.items?.[0]?.title || 'N/A'}
                        </span>
                        {row.status === 0 && (
                          <span className="cancel-meta-badge">
                            <i className="bi bi-person-x me-1"></i>{getCancelledByText(row)}
                          </span>
                        )}
                        
                      </div>
                      <div className="header-right">
                        <span className="commission-chip">
                          <i className="bi bi-piggy-bank me-1"></i>₹0
                        </span>
                      </div>
                    </div>

                    {/* Card Body — 4 columns */}
                    <div className="order-card-body">

                      {/* Col 1: Route */}
                      <div className="info-col">
                        <div className="col-label"><i className="bi bi-map me-1"></i>Route</div>
                        <div className="route-wrap">
                          <div className="route-point">
                            <div className="route-dot" style={{ background: '#10b981', boxShadow: '0 0 0 3px #d1fae5' }}></div>
                            <div className="route-text">
                              <span className="route-tiny">PICKUP</span>
                              <span className="route-addr">{row?.items?.[0]?.pickup || row?.location || 'N/A'}</span>
                              <span className="route-extra">Full: {row?.pickupFullAddress || row?.items?.[0]?.pickupFullAddress || row?.items?.[0]?.pickup || row?.location || 'N/A'}</span>
                            </div>
                          </div>
                          <div className="route-line"></div>
                          <div className="route-point">
                            <div className="route-dot" style={{ background: '#ef4444', boxShadow: '0 0 0 3px #fee2e2' }}></div>
                            <div className="route-text">
                              <span className="route-tiny">DROP</span>
                              <span className="route-addr">{row?.items?.[0]?.dropoff || 'N/A'}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Col 2: Customer */}
                      <div className="info-col">
                        <div className="col-label"><i className="bi bi-person me-1"></i>Customer</div>
                        <div className="detail-list">
                          <div className="detail-item">
                            <i className="bi bi-person-fill" style={{ color: '#3b82f6', fontSize: 13, marginTop: 2 }}></i>
                            <div>
                              <div className="detail-main">{row?.details?.[0]?.username || 'N/A'}</div>
                              <div className="detail-sub">{row?.details?.[0]?.email || '—'}</div>
                            </div>
                          </div>
                          <div className="detail-item">
                            <i className="bi bi-telephone-fill" style={{ color: '#10b981', fontSize: 13, marginTop: 2 }}></i>
                            <div className="detail-main">{row?.details?.[0]?.phone || 'N/A'}</div>
                          </div>
                          <div className="detail-item">
                            <i className="bi bi-telephone-plus-fill" style={{ color: '#f59e0b', fontSize: 13, marginTop: 2 }}></i>
                            <div>
                              <div className="detail-main">{row?.alternativePhone || row?.items?.[0]?.alternativePhone || 'N/A'}</div>
                              <div className="detail-sub">Alternative phone</div>
                            </div>
                          </div>
                          <div className="detail-item">
                            <i className="bi bi-house-fill" style={{ color: '#f59e0b', fontSize: 13, marginTop: 2 }}></i>
                            <div className="detail-main">{row?.details?.[0]?.address || 'N/A'}</div>
                          </div>
                          <div className="detail-item">
                            <i className="bi bi-clock-fill" style={{ color: '#8b5cf6', fontSize: 13, marginTop: 2 }}></i>
                            <div>
                              <div className="detail-main">{row?.items?.[0]?.date || 'N/A'}</div>
                              <div className="detail-sub">{row?.items?.[0]?.time || 'N/A'}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Col 3: Driver */}
                      <div className="info-col">
                        <div className="col-label"><i className="bi bi-person-badge me-1"></i>Driver</div>
                        {row.agentId ? (
                          <div className="driver-card assigned">
                            <DriverAvatar driver={row.agentId} />
                            <div className="driver-info">
                              <div className="driver-name">{row.agentId?.username}</div>
                              <div className="driver-phone">{row.agentId?.phone}</div>
                            </div>
                            <button
                              className="change-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#modal-driver"
                              onClick={() => selectDriver(row._id, row.agentId?._id, row?.category, 1, {
                                longitude: row?.items?.[0]?.pickupMeta?.lng ?? row?.longitude ?? '',
                                latitude: row?.items?.[0]?.pickupMeta?.lat ?? row?.latitude ?? '',
                              }, 2)}
                              title="Change Driver"
                            >
                              <i className="bi bi-pencil-fill"></i>
                            </button>
                          </div>
                        ) : (
                          <div className="driver-card unassigned">
                            <div className="driver-empty"><i className="bi bi-person-x"></i></div>
                            <div className="driver-info">
                              <div className="driver-name" style={{ color: '#94a3b8' }}>No Driver Assigned</div>
                            </div>
                            <button
                              className="assign-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#modal-driver"
                              onClick={() => selectDriver(row._id, '', row?.category, 1, {
                                longitude: row?.items?.[0]?.pickupMeta?.lng ?? row?.longitude ?? '',
                                latitude: row?.items?.[0]?.pickupMeta?.lat ?? row?.latitude ?? '',
                              }, 2)}
                            >
                              <i className="bi bi-plus me-1"></i>Assign
                            </button>
                          </div>
                        )}
                        <BookingDetailsButton order={row} onClick={setSelectedBookingOrder} />
                        {row.status === 0 && (
                          <div className="cancel-reason">
                            <span className="reason-label"><i className="bi bi-chat-left-dots me-1"></i>Reason</span>
                            <p className="reason-text">{row.comment || row.reason || 'N/A'}</p>
                            <span className="reason-label mt-2"><i className="bi bi-person-x me-1"></i>Cancelled By</span>
                            <p className="reason-text">{getCancelledByText(row)}</p>
                          </div>
                        )}
                      </div>

                      {/* Col 4: Actions */}
                      <div className="info-col controls-col">
                        <div className="col-label"><i className="bi bi-gear me-1"></i>Controls</div>

                        {/* Status */}
                        <div className="ctrl-group">
                          <span className="ctrl-mini-label">Ride Status</span>
                          {!isTerminal ? (
                            <select className="status-select" value={row.status} onChange={handleStatusChange(row._id)}>
                              <option value="1">🕐 Placed</option>
                              <option value="2">✅ Accepted</option>
                              <option value="5">🚀 Started</option>
                            </select>
                          ) : (
                            <span className="status-final" style={{ color: statusCfg.color, background: statusCfg.bg }}>
                              <i className={`bi ${statusCfg.icon} me-1`}></i>{statusCfg.label}
                            </span>
                          )}
                        </div>

                        {/* Buttons */}
                        <div className="action-btns">
                          <Link className="act-btn view-btn" to={`/order/${row._id}`}>
                            <i className="bi bi-eye me-1"></i>View
                          </Link>

                          <button className="act-btn driver-invoice-btn" onClick={() => downloadDriverInvoice(row._id)}>
                            <i className="bi bi-file-earmark-pdf me-1"></i>Driver Invoice
                          </button>

                          <button className="act-btn customer-invoice-btn" onClick={() => downloadCustomerInvoice(row._id)}>
                            <i className="bi bi-file-earmark-person me-1"></i>Customer Invoice
                          </button>

                          {!isTerminal && !row.startTime && (
                            cancelOrderId === row._id ? (
                              <div className="cancel-form">
                                <select
                                  className="cancel-by-select"
                                  value={cancelledBy}
                                  onChange={(e) => setCancelledBy(e.target.value)}
                                >
                                  <option value="admin">Cancel by admin</option>
                                  <option value="user">Cancel by user</option>
                                  <option value="driver">Cancel by driver</option>
                                </select>
                                <textarea
                                  rows={2}
                                  placeholder="Reason for cancellation..."
                                  value={cancelComment}
                                  onChange={(e) => setCancelComment(e.target.value)}
                                />
                                <div className="cancel-form-row">
                                  <button className="act-btn confirm-btn" onClick={() => handleCancelOrder(row._id)}>
                                    <i className="bi bi-check me-1"></i>Confirm
                                  </button>
                                  <button className="act-btn discard-btn" onClick={() => { setCancelOrderId(null); setCancelComment(''); setCancelledBy('admin'); }}>
                                    <i className="bi bi-x"></i>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <button className="act-btn cancel-btn" onClick={() => { setCancelledBy('admin'); setCancelOrderId(row._id); }}>
                                <i className="bi bi-x-circle me-1"></i>Cancel
                              </button>
                            )
                          )}

                          {!isTerminal && (
                            <button className="act-btn complete-btn" onClick={() => handleCompleteOrder(row._id)}>
                              <i className="bi bi-check2-all me-1"></i>Complete
                            </button>
                          )}

                          <button className="act-btn delete-btn" onClick={() => handleDelete(row._id)}>
                            <i className="bi bi-trash3 me-1"></i>Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* ── Pagination ── */}
          {!loading && data.length > 0 && (
            <div className="pagination-bar">
              <span className="page-info">Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong></span>
              <div className="page-buttons">
                <button className="page-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
                  <i className="bi bi-chevron-left"></i> Prev
                </button>
                <span className="page-current">{currentPage}</span>
                <button className="page-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
                  Next <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ── Driver Modal ── */}
        <div className="modal fade" id="modal-driver" tabIndex={-1} aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header border-0" style={{ background: 'linear-gradient(135deg,#1d4ed8,#3b82f6)', color: '#fff' }}>
                <h5 className="modal-title fw-bold"><i className="bi bi-person-plus-fill me-2"></i>Assign Driver</h5>
                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body p-4">
                <label className="form-label fw-semibold mb-2">Select Driver</label>
                <AssignDriverSelect
                  drivers={AllDriver}
                  selectedDriverId={DriverId}
                  onChange={handleDriverChange}
                />
                <select className="form-select d-none" value={DriverId || ''} onChange={(event) => setDriverId(event.target.value)}>
                  <option value="">— Select Driver —</option>
                  {AllDriver.length > 0 ? AllDriver.map((driver) => (
                    <option value={driver._id} key={driver._id} style={{ color: driver.onDuty ? 'blue' : Number(driver.online) === 1 ? '#059669' : '#dc2626' }}>
                      {driver.username} {driver.onDuty ? '(On Duty) ' : ''}{Number(driver.online) === 1 ? '(Online)' : '(Offline)'}
                      {driver.distanceKm != null ? ` · ${driver.distanceKm.toFixed(2)} km` : ''}
                    </option>
                  )) : <option value="">No drivers available</option>}
                </select>
              </div>
              <div className="modal-footer border-0">
                <button className="btn btn-primary px-4" type="button" data-bs-dismiss="modal" onClick={handleClickDriverChange}>
                  <i className="bi bi-check-circle me-1"></i>Update Driver
                </button>
                <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

        <BookingDetailsModal order={selectedBookingOrder} hideOtp />
      </main>

      <style jsx>{`
        /* PAGE */
        .orders-page {
          padding: 24px 28px;
          min-height: 100vh;
          background: #f1f5f9;
          font-family: 'Segoe UI', system-ui, sans-serif;
        }

        /* HEADER */
        .page-header { margin-bottom: 24px; }
        .page-title { display: flex; align-items: center; gap: 14px; }
        .title-icon {
          width: 48px; height: 48px;
          background: linear-gradient(135deg,#1d4ed8,#3b82f6);
          border-radius: 14px;
          display: flex; align-items: center; justify-content: center;
          color: white; font-size: 22px; flex-shrink: 0;
        }
        .page-title h1 { margin: 0; font-size: 26px; font-weight: 700; color: #0f172a; line-height: 1.2; }
        .page-title p  { margin: 0; color: #64748b; font-size: 14px; }

        /* FILTER */
        .filter-card {
          background: #fff; border-radius: 16px;
          padding: 20px 24px; margin-bottom: 20px;
          box-shadow: 0 1px 3px rgba(0,0,0,.08), 0 4px 16px rgba(0,0,0,.04);
        }
        .filter-row { display: flex; gap: 16px; align-items: flex-end; flex-wrap: wrap; }
        .filter-group { display: flex; flex-direction: column; gap: 6px; }
        .filter-group.flex-1 { flex: 1; }
        .filter-group label { font-size: 12px; font-weight: 600; color: #475569; text-transform: uppercase; letter-spacing: .04em; }
        .filter-group select {
          height: 40px; border: 1.5px solid #e2e8f0; border-radius: 10px;
          padding: 0 12px; font-size: 14px; color: #1e293b;
          background: #f8fafc; outline: none; cursor: pointer; min-width: 100px;
        }
        .filter-group select:focus { border-color: #3b82f6; background: #fff; }
        .filter-input {
          height: 40px; border: 1.5px solid #e2e8f0; border-radius: 10px;
          padding: 0 12px; font-size: 14px; color: #1e293b;
          background: #f8fafc; outline: none; min-width: 145px;
        }
        .filter-input:focus { border-color: #3b82f6; background: #fff; }
        .hour-filter .filter-input { min-width: 110px; }
        .search-input-wrap { position: relative; }
        .search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; font-size: 14px; }
        .search-input-wrap input {
          width: 100%; height: 40px; border: 1.5px solid #e2e8f0; border-radius: 10px;
          padding: 0 12px 0 36px; font-size: 14px; color: #1e293b;
          background: #f8fafc; outline: none;
        }
        .search-input-wrap input:focus { border-color: #3b82f6; background: #fff; }
        .search-btn {
          height: 40px; padding: 0 24px;
          background: linear-gradient(135deg,#1d4ed8,#3b82f6);
          color: #fff; border: none; border-radius: 10px;
          font-size: 14px; font-weight: 600; cursor: pointer;
          transition: all .2s; white-space: nowrap;
        }
        .search-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,130,246,.4); }
        .reset-btn {
          height: 40px; padding: 0 18px;
          background: #fff; color: #475569;
          border: 1.5px solid #e2e8f0; border-radius: 10px;
          font-size: 14px; font-weight: 600; cursor: pointer;
          transition: all .2s; white-space: nowrap;
        }
        .reset-btn:hover { border-color: #94a3b8; background: #f8fafc; }

        /* BULK ACTIONS */
        .bulk-bar {
          display: flex; align-items: center; justify-content: space-between;
          gap: 14px; padding: 12px 16px; margin-bottom: 14px;
          background: #fff; border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,.07);
        }
        .select-all-wrap {
          display: inline-flex; align-items: center; gap: 8px;
          margin: 0; color: #334155; font-size: 14px; font-weight: 600;
          cursor: pointer;
        }
        .select-all-wrap input, .order-select input {
          width: 16px; height: 16px; cursor: pointer;
          accent-color: #1d4ed8;
        }
        .bulk-actions { display: flex; align-items: center; gap: 10px; color: #64748b; font-size: 13px; font-weight: 600; }
        .bulk-delete-btn {
          height: 36px; padding: 0 14px; border-radius: 9px;
          border: 1px solid #fecaca; background: #fef2f2; color: #dc2626;
          font-size: 13px; font-weight: 700; cursor: pointer;
          transition: all .15s;
        }
        .bulk-delete-btn:hover:not(:disabled) { background: #dc2626; color: #fff; border-color: #dc2626; }
        .bulk-delete-btn:disabled { opacity: .45; cursor: not-allowed; }

        /* ORDERS LIST */
        .orders-list { display: flex; flex-direction: column; gap: 14px; }

        /* ORDER CARD */
        .order-card {
          background: #fff; border-radius: 16px;
          box-shadow: 0 1px 3px rgba(0,0,0,.07), 0 4px 16px rgba(0,0,0,.04);
          overflow: hidden;
          animation: slideUp .3s ease both;
          transition: box-shadow .2s, transform .2s;
        }
        .order-card:hover {
          box-shadow: 0 4px 20px rgba(59,130,246,.13), 0 1px 4px rgba(0,0,0,.08);
          transform: translateY(-1px);
        }
        .order-card.selected {
          outline: 2px solid #93c5fd;
          box-shadow: 0 4px 20px rgba(59,130,246,.18), 0 1px 4px rgba(0,0,0,.08);
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* CARD HEADER */
        .order-card-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 10px 18px; background: #f8fafc;
          border-bottom: 1px solid #f1f5f9; flex-wrap: wrap; gap: 8px;
        }
        .header-left  { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
        .header-right { display: flex; align-items: center; gap: 8px; }
        .order-id { font-size: 15px; font-weight: 700; color: #1d4ed8; letter-spacing: .02em; }
        .order-select { display: inline-flex; align-items: center; margin: 0 2px 0 0; }
        .status-badge, .booking-badge, .sub-badge {
          display: inline-flex; align-items: center;
          padding: 3px 10px; border-radius: 20px;
          font-size: 12px; font-weight: 600;
        }
        .sub-badge { background: #f1f5f9; color: #475569; }
        .commission-chip {
          background: #ecfdf5; color: #059669;
          font-size: 12px; font-weight: 700;
          padding: 3px 10px; border-radius: 20px;
          border: 1px solid #bbf7d0;
        }

        /* CARD BODY */
        .order-card-body {
          display: grid;
          grid-template-columns: 2fr 1.5fr 1.5fr 1.3fr;
        }
        .info-col {
          padding: 16px 18px;
          border-right: 1px solid #f1f5f9;
        }
        .info-col:last-child { border-right: none; }
        .col-label {
          font-size: 10px; font-weight: 700;
          text-transform: uppercase; letter-spacing: .08em;
          color: #94a3b8; margin-bottom: 10px;
        }

        /* ROUTE */
        .route-wrap { display: flex; flex-direction: column; }
        .route-point { display: flex; align-items: flex-start; gap: 10px; }
        .route-dot { width: 10px; height: 10px; border-radius: 50%; margin-top: 4px; flex-shrink: 0; }
        .route-line { width: 2px; height: 16px; background: linear-gradient(#10b981,#ef4444); margin-left: 4px; opacity: .35; }
        .route-text { display: flex; flex-direction: column; gap: 1px; }
        .route-tiny { font-size: 9px; font-weight: 700; letter-spacing: .08em; color: #94a3b8; }
        .route-addr { font-size: 13px; color: #1e293b; font-weight: 500; line-height: 1.35; }
        .route-extra { font-size: 11px; color: #64748b; line-height: 1.35; }

        /* DETAIL LIST */
        .detail-list { display: flex; flex-direction: column; gap: 8px; }
        .detail-item { display: flex; align-items: flex-start; gap: 8px; }
        .detail-main { font-size: 13px; font-weight: 600; color: #1e293b; line-height: 1.3; }
        .detail-sub  { font-size: 11px; color: #64748b; }

        /* DRIVER CARD */
        .driver-card {
          display: flex; align-items: center; gap: 10px;
          padding: 10px 12px; border-radius: 10px; margin-bottom: 0;
        }
        .driver-card.assigned   { background: #f0fdf4; border: 1px solid #bbf7d0; }
        .driver-card.unassigned { background: #fef2f2; border: 1px solid #fecaca; }
        .order-text-btn {
          width: 100%;
          margin-top: 8px;
          border: 1px solid #dbeafe;
          background: #eff6ff;
          color: #1d4ed8;
          border-radius: 8px;
          padding: 7px 10px;
          font-size: 12px;
          font-weight: 700;
          cursor: pointer;
          transition: all .15s;
        }
        .cancel-meta-badge {
          display: inline-flex;
          align-items: center;
          padding: 3px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 700;
          color: #dc2626;
          background: #fef2f2;
        }
        .cancel-reason {
          margin-top: 8px;
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 8px;
          padding: 8px 12px;
        }
        .reason-label {
          font-size: 10px;
          font-weight: 700;
          color: #dc2626;
          text-transform: uppercase;
          letter-spacing: .06em;
          display: block;
          margin-bottom: 4px;
        }
        .reason-text {
          margin: 0;
          font-size: 12px;
          color: #7f1d1d;
          line-height: 1.4;
        }
        .order-text-btn:hover { background: #1d4ed8; color: #fff; border-color: #1d4ed8; }
        .booking-modal-content {
          border-radius: 0;
          overflow: hidden;
          background: #fff;
        }
        .booking-modal-header {
          background: linear-gradient(90deg, #42c6ed, #0879bd);
          color: #fff;
          min-height: 72px;
          padding: 20px 26px;
        }
        .booking-modal-header .modal-title {
          font-size: 27px;
          font-weight: 500;
          letter-spacing: 0;
        }
        .booking-modal-body {
          padding: 36px 42px 28px;
          max-height: 72vh;
          overflow-y: auto;
        }
        .booking-modal-title {
          margin: 0 0 26px;
          font-size: 34px;
          line-height: 1.15;
          font-weight: 500;
          color: #263238;
          letter-spacing: 0;
        }
        .booking-detail-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          column-gap: 38px;
          row-gap: 0;
        }
        .booking-detail-item {
          min-height: 82px;
          padding: 0 0 18px;
          border-bottom: 1px solid #e6eaee;
        }
        .booking-detail-label {
          margin-bottom: 14px;
          color: #202733;
          font-size: 20px;
          line-height: 1.2;
          font-weight: 800;
        }
        .booking-detail-value {
          color: #202733;
          font-size: 18px;
          line-height: 1.45;
          font-weight: 500;
          white-space: pre-wrap;
          word-break: break-word;
        }
        .driver-avatar {
          width: 34px; height: 34px; border-radius: 50%;
          background: linear-gradient(135deg,#1d4ed8,#3b82f6);
          color: white; font-size: 14px; font-weight: 700;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .driver-avatar-img {
          border-radius: 50%;
          object-fit: cover;
          flex-shrink: 0;
          border: 1px solid #dbeafe;
        }
        .driver-select-option {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .driver-select-option.selected {
          gap: 8px;
        }
        .driver-select-copy {
          min-width: 0;
        }
        .driver-select-name {
          font-size: 13px;
          font-weight: 700;
          color: #1e293b;
          line-height: 1.25;
        }
        .driver-select-meta {
          font-size: 11px;
          color: #64748b;
          line-height: 1.25;
        }
        .driver-status-badge {
          display: inline-flex;
          align-items: center;
          border-radius: 999px;
          padding: 2px 7px;
          margin-left: 6px;
          font-size: 10px;
          font-weight: 800;
          line-height: 1.2;
        }
        .driver-empty {
          width: 34px; height: 34px; border-radius: 50%;
          background: #fecaca; color: #ef4444; font-size: 16px;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .driver-info { flex: 1; min-width: 0; }
        .driver-name  { font-size: 13px; font-weight: 600; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .driver-phone { font-size: 11px; color: #64748b; }
        .change-btn {
          width: 28px; height: 28px; border-radius: 8px; border: none;
          background: #dbeafe; color: #1d4ed8; font-size: 12px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; transition: all .15s;
        }
        .change-btn:hover { background: #1d4ed8; color: #fff; }
        .assign-btn {
          padding: 4px 10px; border-radius: 8px; border: none;
          background: #ef4444; color: white; font-size: 12px; font-weight: 600;
          cursor: pointer; flex-shrink: 0; transition: all .15s;
        }
        .assign-btn:hover { background: #dc2626; }

        /* CONTROLS */
        .controls-col { display: flex; flex-direction: column; gap: 10px; }
        .ctrl-group   { display: flex; flex-direction: column; gap: 4px; }
        .ctrl-mini-label { font-size: 10px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: .06em; }
        .status-select {
          width: 100%; height: 34px; border: 1.5px solid #e2e8f0; border-radius: 8px;
          padding: 0 8px; font-size: 13px; font-weight: 600; color: #1e293b;
          background: #f8fafc; outline: none; cursor: pointer;
        }
        .status-select:focus { border-color: #3b82f6; }
        .status-final {
          display: inline-flex; align-items: center;
          padding: 5px 10px; border-radius: 8px;
          font-size: 12px; font-weight: 600;
        }

        /* ACTION BUTTONS */
        .action-btns { display: flex; flex-direction: column; gap: 6px; }
        .act-btn {
          display: inline-flex; align-items: center; justify-content: center;
          padding: 7px 10px; border-radius: 8px;
          font-size: 12px; font-weight: 600; border: none;
          cursor: pointer; text-decoration: none; transition: all .15s; width: 100%;
        }
        .view-btn   { background: #eff6ff; color: #1d4ed8; }
        .view-btn:hover { background: #1d4ed8; color: #fff; }
        .driver-invoice-btn { background: #f5f3ff; color: #7c3aed; border: 1px solid #ddd6fe; }
        .driver-invoice-btn:hover { background: #7c3aed; color: #fff; border-color: #7c3aed; }
        .customer-invoice-btn { background: #ecfdf5; color: #059669; border: 1px solid #bbf7d0; }
        .customer-invoice-btn:hover { background: #059669; color: #fff; border-color: #059669; }
        .cancel-btn { background: #fffbeb; color: #d97706; border: 1px solid #fde68a; }
        .cancel-btn:hover { background: #f59e0b; color: #fff; border-color: #f59e0b; }
        .complete-btn { background: #ecfdf5; color: #059669; border: 1px solid #bbf7d0; }
        .complete-btn:hover { background: #059669; color: #fff; border-color: #059669; }
        .delete-btn { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }
        .delete-btn:hover { background: #dc2626; color: #fff; border-color: #dc2626; }
        .confirm-btn { background: #ef4444; color: #fff; flex: 1; }
        .confirm-btn:hover { background: #dc2626; }
        .discard-btn { background: #f1f5f9; color: #64748b; width: 36px; padding: 7px; flex-shrink: 0; }
        .discard-btn:hover { background: #e2e8f0; }
        .cancel-form textarea {
          width: 100%; border: 1.5px solid #fde68a; border-radius: 8px;
          padding: 6px 10px; font-size: 12px; resize: none; outline: none;
          color: #1e293b; background: #fffbeb; margin-bottom: 6px;
        }
        .cancel-by-select {
          width: 100%; height: 34px; border: 1.5px solid #fde68a; border-radius: 8px;
          padding: 0 10px; font-size: 12px; color: #1e293b; background: #fff;
          outline: none; margin-bottom: 6px;
        }
        .cancel-form-row { display: flex; gap: 6px; }

        /* EMPTY */
        .empty-state {
          text-align: center; padding: 80px 20px;
          background: #fff; border-radius: 16px;
          box-shadow: 0 1px 3px rgba(0,0,0,.07);
        }
        .empty-state i { font-size: 56px; color: #cbd5e1; display: block; margin-bottom: 16px; }
        .empty-state h3 { color: #475569; font-weight: 600; margin-bottom: 6px; }
        .empty-state p  { color: #94a3b8; font-size: 14px; }

        /* PAGINATION */
        .pagination-bar {
          display: flex; align-items: center; justify-content: space-between;
          margin-top: 20px; padding: 14px 20px;
          background: #fff; border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,.07);
        }
        .page-info { font-size: 14px; color: #64748b; }
        .page-info strong { color: #1e293b; }
        .page-buttons { display: flex; align-items: center; gap: 8px; }
        .page-btn {
          display: flex; align-items: center; gap: 4px;
          padding: 7px 16px; border: 1.5px solid #e2e8f0; border-radius: 8px;
          background: #fff; color: #475569; font-size: 13px; font-weight: 600;
          cursor: pointer; transition: all .15s;
        }
        .page-btn:hover:not(:disabled) { border-color: #3b82f6; color: #1d4ed8; background: #eff6ff; }
        .page-btn:disabled { opacity: .4; cursor: not-allowed; }
        .page-current {
          width: 36px; height: 36px; background: #1d4ed8; color: #fff;
          border-radius: 8px; display: flex; align-items: center; justify-content: center;
          font-size: 14px; font-weight: 700;
        }

        /* RESPONSIVE */
        @media (max-width: 1100px) {
          .order-card-body { grid-template-columns: 1fr 1fr; }
          .info-col { border-right: none; border-bottom: 1px solid #f1f5f9; }
          .info-col:nth-child(odd) { border-right: 1px solid #f1f5f9; }
          .info-col:nth-last-child(-n+2) { border-bottom: none; }
        }
        @media (max-width: 640px) {
          .order-card-body { grid-template-columns: 1fr; }
          .info-col { border-right: none !important; border-bottom: 1px solid #f1f5f9; }
          .info-col:last-child { border-bottom: none; }
          .orders-page { padding: 16px; }
          .bulk-bar { align-items: flex-start; flex-direction: column; }
          .bulk-actions { width: 100%; justify-content: space-between; }
          .booking-modal-body { padding: 26px 22px; }
          .booking-modal-title { font-size: 28px; }
          .booking-detail-grid { grid-template-columns: 1fr; }
          .booking-detail-label { font-size: 17px; }
          .booking-detail-value { font-size: 15px; }
        }
      `}</style>
    </>
  );
}

export default AllOrder;
